import { Component, inject, OnInit } from '@angular/core';
import { WdxSpinnerModule } from '@wdx/shared/components/wdx-spinner';
import { take } from 'rxjs';
import { AuthenticationService } from '../../services/authentication/authentication.service';

@Component({
    templateUrl: './welcome.component.html',
    styleUrls: ['./welcome.component.scss'],
    imports: [WdxSpinnerModule],
})
export class WelcomeComponent implements OnInit {
    private authenticationService = inject(AuthenticationService);

    ngOnInit(): void {
        this.authenticationService.login().pipe(take(1)).subscribe();
    }
}
